export default {
  title: 'API Keys',
  createKeyButton: 'Create API Key',
  tooltips: {
    viewKey: 'View your key',
    duplicateKey: 'Duplicate your key',
    deleteKey: 'Delete your key',
  },
  createdOn: 'Created on',
  addKeyModal: {
    title: 'Add API key',
    nameField: 'Name',
    saveButton: 'Save',
    cancelButton: 'Cancel',
  },
  duplicateKeyModal: {
    title: 'Copy API key',
    nameField: 'Name',
    saveButton: 'Save',
    cancelButton: 'Cancel',
  },
  viewKeyModal: {
    title: 'View API key',
    cancelButton: 'Close',
  },
  deleteKey: {
    alertText:
      'WARNING: Deleting this token will mean that any existing external service using it will be no longer be able to communicate with SchemeServe.',
    cancelButton: 'Cancel',
    deleteButton: 'Delete',
  },
  viewNewKeyModal: {
    alertText:
      'WARNING: Please copy this key and save it somewhere safe. For security reasons, we cannot show it to you again',
    title: 'API Key: {{keyName}}',
    keyContainerLabel: 'API Key',
    copySuccessText: 'Copied to clipboard.',
    doneButton: 'Done',
  },
};
